// extracted by css-extract-rspack-plugin
export default {"spinnerContainer":"_bc7aeef3","fade":"_17892eef","spinner":"_2e5c3b4"};